import React, { useState, useRef, useEffect } from "react";
import "./IconDropdown.css";

interface DropdownOption {
  value: string;
  label: string;
  icon: React.ReactNode;
}

interface IconDropdownProps {
  options: DropdownOption[];
  selected: DropdownOption;
  onChange: (option: DropdownOption) => void;
  className?: string;
}

const IconDropdown: React.FC<IconDropdownProps> = ({
  options,
  selected,
  onChange,
  className = "",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleOptionClick = (option: DropdownOption) => {
    onChange(option);
    setIsOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      className={`icon-dropdown-container ${className}`}
      ref={dropdownRef}
    >
      <div className="icon-dropdown-selected" onClick={toggleDropdown}>
        <div className="icon-dropdown-selected-content">
          {selected.icon}
          <span>{selected.label}</span>
        </div>
        <span className="icon-dropdown-arrow">▼</span>
      </div>
      {isOpen && (
        <div className="icon-dropdown-options">
          {options.map((option) => (
            <div
              key={option.value}
              className={`icon-dropdown-option ${
                selected.value === option.value ? "selected" : ""
              }`}
              onClick={() => handleOptionClick(option)}
            >
              {option.icon}
              <span>{option.label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default IconDropdown;
